import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Populaarsemast

  <span style="color:#85c1dc;">**FI:**</span>
  Osuvuuden

  <span style="color:#85c1dc;">**RU:**</span>
  Популярные сверху
*/
/* @__NO_SIDE_EFFECTS__ */
const m102 = msg(
  mf`Populaarsemast`,
  mf`Osuvuuden`,
  mf`Популярные сверху`,
)

export { m102 as 'w.saal.reasta.populaarsus' }